module.exports = __webpack_public_path__ + "static/altpro-bw-b9ffe26de01ef0c450925a76e8775a13.jpg";